
const headers = accessToken => [
        {key: "Authorization", value: "Bearer " + accessToken }
    ];


const profile = http => apiUrl => accessToken => userId => {
    const url = `${apiUrl}/users/${userId}/profile`
    return http("GET", url, headers(accessToken))
    .catch(() => Promise.reject("REMOTE ERROR"))
    .then(r => {
        if (r.status !== 200) {
            return Promise.reject("ERROR RESPONSE");
        } else if (!r.payload || !r.payload.items ) {
            return Promise.reject("UNEXPECTED CONTENT");
        } else return r;
    })
    .then(r => r.payload.items[0])
    ;
};

export { profile };



// WEBPACK FOOTER //
// ./src/user/operations-service.js